export default {
  data() {
    return {
      menu: this.$services.resolve('menu'),
    };
  },
  computed: {
    menuItems() {
      if (this.subscriber.isKidsTheme) {
        return this.menu.data.desktopKids;
      }

      return this.menu.data.desktop;
    },
    currentMenuElement() {
      return this.menuItems.find(({ url }) => this.$route.path.startsWith(url)) || this.menuItems.find(({ elements }) => elements?.find(({ url }) => this.$route.path.startsWith(url)));
    },
  },
};
